/**
 * Form hook — creates useAppForm, withForm, and withFieldGroup
 * with our pre-registered field and form components.
 */
import { createFormHook } from '@tanstack/react-form'

import { fieldContext, formContext } from '@/customer/components/form/form-context'

import { SubmitButton } from './components/submit-button'
import { CardRadioGroupField, InputField, SelectField, TextareaField } from './fields'

export const { useAppForm, withForm, withFieldGroup } = createFormHook({
  fieldComponents: {
    InputField,
    TextareaField,
    SelectField,
    CardRadioGroupField,
  },
  formComponents: {
    SubmitButton,
  },
  fieldContext,
  formContext,
})

export { FormLayoutProvider } from './layouts/form-layout-context'
